import * as React from "react";
import {Field} from "react-final-form";
import {TiposDocumental} from "../../documentos/modelo/TiposDocumental";


export default class TipoDocumental extends React.Component<TipoDocumentalProps> {

    render() {
        const {className,tipoCliente} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            {
                                TiposDocumental
                                .filter(tipos => tipos.tipoCliente.find(tipo => tipo === tipoCliente))
                                .map(
                                    tipo => {
                                        return <option key={tipo.titulo} value={tipo.titulo}>{tipo.titulo}</option>;
                                    }
                                )
                            }
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

}

interface TipoDocumentalProps {
    name: string,
    className?: string,
    tipoCliente?: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/TipoDocumental.tsx